import gsap from "gsap";

const _titoloImmagineTestata = (() => {
    const init = () => {
        const fascia = document.querySelector<HTMLElement>(".titolo-immagine-testata");

        if (!fascia) return;

        const titolo = fascia.querySelector(".titolo-container .template-h1");
        const testoSinistra = fascia.querySelector<HTMLElement>(".sinistra .template-h2");
        const testoDestra = fascia.querySelector<HTMLElement>(".destra .template-frase-effetto");
        const imgContainer = fascia.querySelector<HTMLImageElement>(".media-container");

        const [primaParte, secondaParte] = Array.from(titolo?.children ?? []);
        const [stella, testo] = Array.from(secondaParte?.children ?? []);

        const mmDesktopString = "(min-width: 992px)";
        const mmMobileString = "(max-width: 991px)";

        const mm = gsap.matchMedia();

        mm.add(mmMobileString, () => {
            const tl = gsap.timeline({
                defaults: {
                    duration: 0.6,
                },
                scrollTrigger: {
                    trigger: titolo,
                    start: "center 70%",
                },
            });

            tl.from(primaParte, {
                x: -500,
                ease: "back.out(0.5)",
            })
                .from(
                    imgContainer,
                    {
                        clipPath: "inset(35%)",
                        ease: "power2.in",
                    },
                    "<",
                )
                .to(stella, {
                    opacity: 1,
                    duration: 0.2,
                })
                .from(
                    stella,
                    {
                        scale: 0,
                        ease: "back.out(5)",
                    },
                    "<",
                )
                .to(
                    stella,
                    {
                        opacity: 0,
                    },
                    ">+0.5",
                )
                .from(
                    testo,
                    {
                        x: 500,
                        ease: "back.out(0.5)",
                    },
                    ">-0.5",
                )
                .moveTitle(testoSinistra, {
                    x: 1,
                    distance: 30,
                    stagger: 0.1,
                })
                .moveTitle(testoDestra, {
                    x: 1,
                    distance: 30,
                    stagger: 0.1,
                });
        });

        mm.add(mmDesktopString, () => {
            const tl = gsap.timeline({
                defaults: {
                    duration: 1,
                },
                scrollTrigger: {
                    trigger: titolo,
                    start: "center 70%",
                },
            });

            tl.from(stella.querySelector("svg"), {
                scale: 0,
                ease: "back.out(2)",
            })
                .from(
                    stella.querySelector("svg"),
                    {
                        opacity: 0,
                        duration: 0.3,
                    },
                    "<",
                )
                .from(
                    imgContainer,
                    {
                        clipPath: "inset(35%)",
                        ease: "power2.in",
                    },
                    "<",
                )
                .from(primaParte, {
                    x: "-50vw",
                })
                .from(
                    testo,
                    {
                        x: "50vw",
                    },
                    "<",
                )
                .moveTitle(testoSinistra, {
                    x: 1,
                    distance: 30,
                    stagger: 0.1,
                })
                .moveTitle(testoDestra, {
                    x: 1,
                    distance: 30,
                    stagger: 0.1,
                });
        });
    };

    return {
        init: init,
    };
})();

export default _titoloImmagineTestata;
